import React from 'react';
import classNames from 'classnames';

import css from './IconBillList.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconBillList = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.34 2.66675H9.66002C8.11486 2.66675 7.34228 2.66675 6.71918 2.88356C5.53763 3.29469 4.60997 4.24967 4.21061 5.46603C4 6.10748 4 6.90282 4 8.4935V27.1657C4 28.31 5.31333 28.9171 6.14413 28.1569C6.63223 27.7102 7.36777 27.7102 7.85587 28.1569L8.5 28.7463C9.35545 29.5291 10.6446 29.5291 11.5 28.7463C12.3554 27.9635 13.6446 27.9635 14.5 28.7463C15.3554 29.5291 16.6446 29.5291 17.5 28.7463C18.3554 27.9635 19.6446 27.9635 20.5 28.7463C21.3554 29.5291 22.6446 29.5291 23.5 28.7463L24.1441 28.1569C24.6322 27.7102 25.3678 27.7102 25.8559 28.1569C26.6867 28.9171 28 28.31 28 27.1657V8.4935C28 6.90282 28 6.10748 27.7894 5.46603C27.39 4.24967 26.4624 3.29469 25.2808 2.88356C24.6577 2.66675 23.8851 2.66675 22.34 2.66675Z"
        stroke="#113A69"
        stroke-width="1.5"
      />
      <path
        d="M14 14.6667L22.6667 14.6667"
        stroke="#113A69"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M9.33398 14.6667H10.0007"
        stroke="#113A69"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path d="M9.33398 10H10.0007" stroke="#113A69" stroke-width="1.5" stroke-linecap="round" />
      <path
        d="M9.33398 19.3333H10.0007"
        stroke="#113A69"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path d="M14 10H22.6667" stroke="#113A69" stroke-width="1.5" stroke-linecap="round" />
      <path d="M14 19.3333H22.6667" stroke="#113A69" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  );
};

export default IconBillList;
